import { render, staticRenderFns } from "./AdminExplorer.vue?vue&type=template&id=70cb60c5&"
import script from "./AdminExplorer.vue?vue&type=script&lang=js&"
export * from "./AdminExplorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports